import React from 'react';

export class Constants {
	static currencyList = {
		doller: {
			sign: '$',
			name: 'دلار',
			field: 'doller',
		},
		toman: {
			sign: 'ت',
			name: 'تومان',
			field: 'toman',
		}
	};


	// static SERVER_IP_PORT = "127.0.0.1:9128"; static LOCAL_HOST = true; static DEVELOPMENT_MODE = true; static CUSTOMER_SERVER_IP_PORT = "192.168.31.166:3000";
	// static SERVER_IP_PORT = "192.168.1.90:9128"; static LOCAL_HOST = true; static DEVELOPMENT_MODE = true; static CUSTOMER_SERVER_IP_PORT = "127.0.0.1:3000";
	// static SERVER_IP_PORT = "127.0.0.1:9127"; static LOCAL_HOST = true; static DEVELOPMENT_MODE = true; static CUSTOMER_SERVER_IP_PORT = "127.0.0.1:3000";
	// static SERVER_IP_PORT = "bitbite.net:70"; static LOCAL_HOST = true; static DEVELOPMENT_MODE = true;
	// static SERVER_IP_PORT = "bo.testk.ir"; static LOCAL_HOST = true; static DEVELOPMENT_MODE = true;
	// static SERVER_IP_PORT = "bots.testk.ir"; static LOCAL_HOST = true; static DEVELOPMENT_MODE = true;
	// static DEVELOPMENT_MODE = true;

	static SERVER_IP_PORT = process.env.REACT_APP_SERVER_IP_PORT;
	static LOCAL_HOST = process.env.REACT_APP_LOCAL_HOST;
	static DEVELOPMENT_MODE = process.env.REACT_APP_DEVELOPMENT_MODE;
	static BOT_APP = process.env.REACT_APP_BOT_APP;
	static BO_APP = process.env.REACT_APP_BO_APP;


	static API_URL = Constants.LOCAL_HOST ? ("http://" + Constants.SERVER_IP_PORT + "/api/") : "/api/";

	static UPLOAD_SERVER = { localServer: true, url: Constants.API_URL + 'upload' };
	static LoginAppService = 'BitbiteAppService';

	static API_URL_REGISTER = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/register", type: 'POST' };
	static API_URL_REGISTER_PERSON = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/register-person", type: 'POST' };
	static API_URL_REGISTER_NEW_USER = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/register-new-user", type: 'POST' };
	static API_URL_REGISTER_USER = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/register-user", type: 'POST' };
	static API_URL_VERIFY = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/verify", type: 'POST' };

	static API_URL_SET_PROFILE_PICTURE = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/setprofilepicture", type: 'PUT' };
	static API_URL_LOGIN = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/login", type: 'POST' };
	static API_URL_GOOGLE_AUTH = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/google-auth", type: 'POST' };
	static API_URL_LOGIN_OTP = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/loginotp", type: 'POST' };
	static API_URL_RESEND_CODE = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/resend-password", type: 'POST' };
	static API_URL_SEARCH_PERSON = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/searchperson", type: 'GET' };
	static API_URL_PASSWORD_SET = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/set-password", type: 'PUT' };
	static API_URL_PROFILE_SET = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/set-profile", type: 'PUT' };
	static API_URL_PROFILE_GET = { name: ["Bitbite", "Project"], url: Constants.API_URL + "bitbiteappservice/get-profile", type: 'PUT' };
	static API_URL_FRANO_SET_BUSINESS_SERVICE_ACCESS = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/set-business-service-access", type: 'PUT' };
	static API_URL_FRANO_ACCESS_ADD = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/add-access", type: 'PUT' };
	static API_URL_FRANO_ACCESS_REMOVE = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/remove-access", type: 'PUT' };
	static API_URL_FRANO_PERSON_DELETE = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/remove-person", type: 'POST' };
	static API_URL_FRANO_GET_USER_ACCESS_LIST = { name: "Bitbite", url: Constants.API_URL + "bitbiteappservice/get-user-access-list", type: 'GET' };

	static API_URL_CONFIG_PREPARE_EDIT = { name: ['Bitbite', 'Project'], url: Constants.API_URL + "bitbiteappservice/prepare-config", type: 'GET' };
	static API_URL_CONFIG_SET = { name: ['Bitbite', 'Project'], url: Constants.API_URL + "bitbiteappservice/set-config", type: 'PUT' };
	static API_URL_CAPTCHA = { name: ['Bitbite'], url: Constants.API_URL + "bitbiteappservice/captcha", type: 'PUT' };

	static CHART = [
		{ key: 1, value: { en: 'CHART_ITEM_1', fa: 'پژوهش' } },
		{ key: 2, value: { en: 'CHART_ITEM_2', fa: 'معاونت توسعه' } },
	];

	static DEGREES = [
		{ key: 1, value: { en: 'DEGREES_ITEM_1', fa: 'Bachelor' } },
		{ key: 3, value: { en: 'DEGREES_ITEM_3', fa: 'Ph.D.' } },
	];

	static systemAccessList = [
		Constants.ACCESS_SERVICE_BITBITE,
	];

	static LOADER_COLOR = '#17B2E7';

	static LANGUAGE_INDEX = 0;
	static tokens = [];

	static GENERAL_FLOOR = -101;
	static DIFFERENT = -100;
	static FLOOR_MINUS_2 = -2;
	static UNDERGROUND_FLOOR = -1;
	static GROUND_LEVEL = 0;


	static LANGUAGES = [{
		dateName: 'SHAMSI',
		lang: 'fa',
		htmlDir: 'rtl',
		img: 'ir.svg',
		dateFormat: "jYYYY/jMM/jDD",
		dateFormatStr: "jDD jMMMM jYYYY",
		dateTimeFormat: "jYYYY/jMM/jDD HH:mm",
		dateTimeFormatShort: "jYY/jMM/jDD HH:mm",
		dateTimeFormatShort2: "HH:mm jYYYY/jMM/jDD",
		dateFullTimeFormat: "jYYYY/jMM/jDD HH:mm a",
		dateFullTimeFormatStr: "jDD jMMMM jYYYY HH:mm a",
		monthName: "jMMMM jYYYY",
		monthField: "jMonth",
		monthFieldSmall: "jmonth",
		weekDays: ['شنبه', 'یکشنبه', 'دوشنبه', 'سه‌شنبه', 'چهارشنبه', 'پنج‌شنبه', 'جمعه'],
		appName: 'سامانه نوآوری فرانو',
	}, {
		dateName: 'MILADY',
		lang: 'en',
		htmlDir: 'ltr',
		img: 'us.svg',
		dateFormat: "MM/DD/YYYY",
		dateFormatStr: "YYYY MMMM DD",
		dateFormatStr2: "DD MMMM YYYY",
		dateTimeFormatStr: "MM/DD/YYYY HH:mm",
		dateTimeFormatShort: "MM/DD/YY HH:mm",
		dateFullTimeFormat: "MM/DD/YYYY HH:mm",
		dateFullTimeFormatStr: "YYYY MMMM DD HH:mm",
		monthName: "MMMM YYYY",
		monthField: "month",
		monthFieldSmall: "month",
		weekDays: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
		appName: 'Bitbite System',
	}];
	static ACTIVE_LANGUAGE = Constants.LANGUAGES[Constants.LANGUAGE_INDEX];
	static i18n = (t) => t;
	static totalCode = 0;
	static maxCode = 3;
	static ANONYMOUS_USER = 'BITBITE_ANONYMOUS_USER';
	static SYSTEM_ID = "BITBITE";

	static SystemList = [
		{ value: { en: 'BITBITE', fa: 'کاشانو' } },
	];
	static loginInfo = '';

	static ACCESS_GENERAL_BITBITE_USER = { service: 'bitbite', index: 0, value: 1 << 0 };
	static ACCESS_BITBITE_FORBIDDEN = { service: 'bitbite', index: 0, value: 1 << 1 };
	static ACCESS_BITBITE_MANAGEMENT = { service: 'bitbite', index: 0, value: 1 << 2 };
	static ACCESS_BITBITE_SUPPORT = { service: 'bitbite', index: 0, value: 1 << 3 };
	static ACCESS_BITBITE_PORTION = { service: 'bitbite', index: 0, value: 1 << 4 };
	static ACCESS_BITBITE_PACKAGING = { service: 'bitbite', index: 0, value: 1 << 5 };
	static ACCESS_BITBITE_MARKETING = { service: 'bitbite', index: 0, value: 1 << 6 };

	static FIRST_APP_RELEASE_DATE = "1401/11/28";
}

export const AppContext = React.createContext({});
export const GeneralContext = React.createContext();


